import { render, staticRenderFns } from "./SpecificationPreview.vue?vue&type=template&id=5ece5c93&scoped=true"
import script from "./SpecificationPreview.vue?vue&type=script&lang=js"
export * from "./SpecificationPreview.vue?vue&type=script&lang=js"
import style0 from "./SpecificationPreview.vue?vue&type=style&index=0&id=5ece5c93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ece5c93",
  null
  
)

export default component.exports